import config from '../../config';

export default {
  url: `${config.api.baseURL}/menus`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/menus/list.js